import { TIMING_PRESETS } from '@usepepper/sprout-kit-ui';
import { useEffect, useState } from 'react';

/**
 * Keeps an overlay mounted for its close animation, then unmounts it.
 *
 * @param isOpen - Whether the overlay is open.
 * @param durationMs - Close animation duration to wait out before unmounting.
 * @returns Whether the overlay should be rendered.
 */
export const useDeferredUnmount = (
  isOpen: boolean,
  durationMs: number = TIMING_PRESETS.sheetSlide.duration,
): boolean => {
  const [shouldRender, setShouldRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      return;
    }
    const timeout = setTimeout(() => setShouldRender(false), durationMs);
    return () => clearTimeout(timeout);
  }, [durationMs, isOpen]);

  return shouldRender;
};
